<template>
  <div class="videoList-box" style="height: 100%">
    <!--操作栏-->
    <el-form ref="params" :model="params" label-width="auto">
      <el-row :gutter="12">
        <el-col :span="6">
          <el-form-item label="审核状态" style="margin-bottom: 0">
            <el-select
              style="width: 100%"
              v-model="params.status"
              placeholder="审核状态"
              size="small"
            >
              <el-option
                v-for="item in status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="帖子精选" style="margin-bottom: 0">
            <el-select
              v-model="params.chosen"
              placeholder="帖子精选"
              style="width: 100%"
              size="small"
            >
              <el-option
                v-for="item in chosen"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="帖子类型" style="margin-bottom: 0">
            <el-select
              v-model="params.newsType"
              placeholder="帖子类型"
              style="width: 100%"
              size="small"
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option label="长视频" :value="1"></el-option>
              <el-option label="图文帖" :value="2"></el-option>
              <el-option label="图集" :value="3"></el-option>
              <el-option label="短视频" :value="6"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否为用户" style="margin-bottom: 0">
            <el-select
              v-model="params.isUserUp"
              placeholder="是否为用户"
              style="width: 100%"
              size="small"
            >
              <el-option
                v-for="item in isUserUp"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="3">
        <el-col :span="6">
          <el-form-item label="是否免费" style="margin-bottom: 0">
            <el-select
              v-model="params.isFree"
              placeholder="是否免费"
              style="width: 100%"
              size="small"
            >
              <el-option
                v-for="item in isFree"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="置顶" style="margin-bottom: 0">
            <el-select
              v-model="params.isTopping"
              style="width: 100%"
              placeholder="置顶"
              size="small"
            >
              <el-option
                v-for="item in isLiaoBaTop"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="标签名" style="margin-bottom: 0">
            <el-input
              v-model="params.tag"
              placeholder="请输入标签名"
              style="width: 100%"
              clearable
              @keyup.enter.native="getVideoList('status')"
              size="small"
              class="param-input"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="用户ID" style="margin-bottom: 0">
            <el-input
              v-model="params.uid"
              style="width: 100%"
              placeholder="请输入用户ID"
              clearable
              size="small"
              class="param-input"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="3">
        <el-col :span="6">
          <el-form-item label="帖子ID" style="margin-bottom: 0">
            <el-input
                v-model="params.id"
                placeholder="请输入帖子ID"
                clearable
                style="width: 100%"
                size="small"
                class="param-input"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="帖子标题" style="margin-bottom: 0">
            <el-input
              v-model="params.title"
              placeholder="请输入帖子标题"
              clearable
              style="width: 100%"
              size="small"
              @keyup.enter.native="getVideoList('status')"
              class="param-input"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="子模块" style="margin-bottom: 0">
            <el-cascader
              style="width: 100%"
              :options="secondModuleList"
              v-model="params.subModuleID"
              :props="{ emitPath: false, expandTrigger: 'hover' }"
              @change="handleChangeModule"
              clearable
              size="small"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="时间" style="margin-bottom: 0">
            <el-date-picker
              v-model="time"
              type="datetimerange"
              style="width: 100%"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
              @change="changeTime"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div></div>

    <div class="action-bar">
      <el-button type="primary" size="small" @click="getVideoList('status')"
        >搜索</el-button
      >
      <el-button type="primary" size="small"
        >一键生成非用户视频点赞和评论</el-button
      >
      <el-button type="primary" size="small" @click="handleBatchChildModule()"
        >批量转移子模块</el-button
      >
      <el-button type="primary" size="small" @click="handleBatchModifyCoin()"
        >批量修改金币价格</el-button
      >

      <el-button type="success" v-if="params.status == 0" size="small" @click="handleBatchRemoves(1)"
      >批量上架
      </el-button>
      <el-button type="primary" v-if="params.status != 0" size="small" @click="handleBatchRemoveSelf()"
      >批量下架</el-button
      >
      <el-button type="primary" size="small"  v-if="params.status != 0" @click="handleBatchRemoves(0)"
      >批量删除
      </el-button>
      <el-button :type="params.empty?'danger':'primary'" size="small" @click="handleSearchNoCategory()"
      >{{ params.empty ? "重置搜索":"查询空专题数据"}}</el-button>
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      size="small"
      ref="currentTableData"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      @sort-change="handleSortChange"
      height="auto"
      @selection-change="handleSelectionChange"
      highlight-current-row
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        prop="id"
        label="帖子ID"
        align="center"
        width="185"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span @click="copyId(scope.row.id)" style="cursor: pointer">{{
            scope.row.id || "未知"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        align="left"
        :show-overflow-tooltip="true"
        width="280"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.title || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="subModuleName"
        label="子模块名称"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column label="审核结果" align="center" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1">审核通过</span>
          <span v-if="scope.row.status === 2">未通过</span>
          <span v-if="scope.row.status === 5">下架</span>
          <span v-if="scope.row.status === 0">已删除</span>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="帖子预览" align="center" width="80">
        <template slot-scope="scope" v-if="scope.row.sourceURL">
          <i
              class="el-icon-video-play views"
              title="点击预览"
              @click="checkMedia(scope.row.sourceURL, 'video')"
          ></i>
        </template>
      </el-table-column>
      <el-table-column label="封面" align="center" width="100">
        <template slot-scope="scope">
          <img-load
              height="30px"
              v-if="showImgLoad && scope.row.cover"
              :src="imgUrl + '/' + scope.row.cover"
          ></img-load>
          <span v-else>暂无图片</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="seriesCover"
          label="图集预览"
          align="center"
          width="120"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.seriesCover || !scope.row.seriesCover.length"
          >未知</span
          >
          <div
              v-else
              class="picturePreview"
              @click="
              previewPicture(
                scope.row.seriesCover,
                scope.row.id,
                scope.row.tags,
                scope.row
              )
            "
          >
            <div v-if="showImgLoad" style="display: flex">
              <div
                  v-for="(item, i) in scope.row.seriesCover"
                  style="margin-right: 5px"
                  :key="i"
              >
                <img-load-collection
                    height="40px"
                    :src="imgUrl + '/' + item"
                ></img-load-collection>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          prop="newsType"
          label="帖子类型"
          align="center"
          width="100"
          :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.newsType == 'SP'">长视频</span>
          <span v-else-if="scope.row.newsType == 'COVER'">图文贴</span>
          <span v-else-if="scope.row.newsType == 'COVER_IMAGE'">图集</span>
          <span v-else-if="scope.row.newsType == 'DSP'">短视频</span>
          <span v-else>其它</span>
        </template>
      </el-table-column>

      <el-table-column label="是否置顶" align="center" width="120">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.isTopping"
              @change="setChosen(scope.row, 'isTopping')"
          ></el-switch>
        </template>
      </el-table-column>

      <el-table-column label="是否推荐" align="center" width="120">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.isRecoWeight"
              @change="setChosen(scope.row, 'isRecoWeight')"
          ></el-switch>
        </template>
      </el-table-column>

      <el-table-column label="是否为精选" align="center" width="120">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.chosen"
              @change="setChosen(scope.row, 'chosen')"
          ></el-switch>
        </template>
      </el-table-column>

      <el-table-column label="是否为免费专区" align="center" width="120">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.freeArea"
              @change="setChosen(scope.row, 'free')"
          ></el-switch>
        </template>
      </el-table-column>

      <el-table-column label="用户ID" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.publisher.uid || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="userName"
          label="用户昵称"
          align="center"
          width="140"
          :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.publisher.name || "未知" }}</span>
        </template>
      </el-table-column>

      <el-table-column
          label="是否为用户"
          align="center"
          width="100"
          :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.isUser ? "是" : "否" }}</span>
        </template>
      </el-table-column>

      <el-table-column
          prop="coins"
          label="价格"
          align="center"
          width="100"
          :sortable="'custom'"
      ></el-table-column>
      <el-table-column
          prop="playTime"
          label="总时长"
          align="center"
          width="130"
          :sortable="'custom'"
      >
        <template slot-scope="scope"
        >{{ scope.row.playTime | changeSecond }}
        </template>
      </el-table-column>
      <el-table-column
          prop="freeTime"
          label="免费时长"
          align="center"
          width="130"
          :sortable="'custom'"
      >
        <template slot-scope="scope"
        >{{ scope.row.freeTime | changeSecond }}
        </template>
      </el-table-column>

      <el-table-column
          prop="reviewAccount"
          label="操作人"
          align="center"
          width="80"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.reviewAccount }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="createdAt"
          label="最后操作时间"
          align="center"
          width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="reviewAt"
          label="审核时间"
          align="center"
          width="160"
          :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.reviewAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="createdAt"
          label="上传时间"
          align="center"
          width="160"
          :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>

      <el-table-column label="是否力荐" align="center" width="120">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.isRecommend"
              @change="setChosen(scope.row, 'isRecommend')"
          ></el-switch>
        </template>
      </el-table-column>

      <el-table-column label="是否围观" align="center" width="120">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.isChoosen"
              @change="setChosen(scope.row, 'isChoosen')"
          ></el-switch>
        </template>
      </el-table-column>

      <el-table-column label="置顶时间" align="center" width="180">
        <template slot-scope="scope">
          {{scope.row.toppedAt | changeDate}}
        </template>
      </el-table-column>


      <el-table-column label="免费刷新时间" align="center" width="180">
        <template slot-scope="scope">
          {{scope.row.freeAreaDate | changeDate}}
        </template>
      </el-table-column>

      <el-table-column label="推荐时间" align="center" width="180">
        <template slot-scope="scope">
          {{scope.row.recoWeightTime | changeDate}}
        </template>
      </el-table-column>

      <el-table-column label="精选刷新时间" align="center" width="180">
        <template slot-scope="scope">
          {{scope.row.chosenDate | changeDate}}
        </template>
      </el-table-column>

      <el-table-column label="力荐刷新时间" align="center" width="180">
        <template slot-scope="scope">
          {{scope.row.recommendTime | changeDate}}
        </template>
      </el-table-column>

      <el-table-column label="围观刷新时间" align="center" width="180">
        <template slot-scope="scope">
          {{scope.row.isChoosenTime | changeDate}}
        </template>
      </el-table-column>

      <el-table-column label="是否撩吧置顶" align="center" width="120" v-if="false">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.liaoBaTop"
              @change="setChosen(scope.row, 'liaoBaTop')"
          ></el-switch>
        </template>
      </el-table-column>

      <el-table-column label="用户ID" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.publisher.uid || "未知" }}</span>
        </template>
      </el-table-column>

      <el-table-column
          prop="coins"
          label="价格"
          align="center"
          width="100"
          :sortable="'custom'"
      ></el-table-column>
      <el-table-column
          prop="playTime"
          label="总时长"
          align="center"
          width="130"
          :sortable="'custom'"
      >
        <template slot-scope="scope"
        >{{ scope.row.playTime | changeSecond }}
        </template>
      </el-table-column>
      <el-table-column
          prop="freeTime"
          label="免费时长"
          align="center"
          width="130"
          :sortable="'custom'"
      >
        <template slot-scope="scope"
        >{{ scope.row.freeTime | changeSecond }}
        </template>
      </el-table-column>

      <el-table-column prop="url" label="原视频下载" align="center" width="100">
        <template slot-scope="scope" v-if="scope.row.sourceURL">
          <el-button
              type="success"
              size="small"
              @click="downloadMedia(scope.row)"
          >
            <i class="el-icon-download" title="原视频下载"></i>
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
          prop="size"
          label="帖子大小(M)"
          align="center"
          width="100"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.size / 1024 / 1024) | transformFloat }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="freeTime"
          label="有效播放率"
          align="center"
          width="120"
      >
        <template slot-scope>
          <span>功能未添加</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="resolution"
          label="清晰度"
          align="center"
          width="100"
          :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.resolution || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="playCount"
          label="播放数(真)"
          align="center"
          width="140"
          :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.playCount || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="fakePlayCount"
          label="播放数(假)"
          align="center"
          width="140"
          :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.fakePlayCount || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="likeCount"
          label="点赞数(真)"
          align="center"
          width="140"
          :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.likeCount || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="fakeLikeCount"
          label="点赞数(假)"
          align="center"
          width="140"
          :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.fakeLikeCount || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="fakeShareCount"
          label="分享数(假)"
          align="center"
          width="140"
          :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.fakeShareCount || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="commentCount"
          label="评论数(真)"
          align="center"
          width="140"
          :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.commentCount || "0") | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="rewarded"
          label="打赏金额"
          align="center"
          width="140"
          :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.rewarded || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="fakeRewarded"
          label="打赏金额(假)"
          align="center"
          width="140"
          :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.fakeRewarded || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <!-- 评论数为真是数据
      <el-table-column prop="fakeCommentCount" label="评论数(假)" align="center" width="140" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{(scope.row.fakeCommentCount || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      -->

      <el-table-column
          prop="reason"
          label="审核失败原因"
          align="center"
          show-overflow-tooltip
          width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.reason || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="170" fixed="right">
        <template slot-scope="scope">
          <el-button type="success" size="mini" v-if="false" @click="openComment(scope.row)"
            >评论</el-button
          >
          <el-button type="success" size="mini" v-if="false" @click="forcePush(scope.row)"
            >强推</el-button
          >
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="edit(scope.row)"
          >编辑</el-button>
          <!--
          <el-tooltip content="置顶" placement="top">
            <el-button type="warning" size="mini" icon="el-icon-upload2" @click="placement(scope.row)"></el-button>
          </el-tooltip>
          -->
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="removeVideo(scope.row.id,scope.$index)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--封面图、视频弹窗组件-->
    <media-popup ref="mediaPopup"></media-popup>
    <!--视频编辑弹窗-->
    <edit-video
      ref="editVideo"
      @handlerVideoList="handlerVideoList"
    ></edit-video>
    <batch-child-module
      ref="batchChildModule"
      @refresh="handlerVideoList"
    ></batch-child-module>
    <!-- 图集预览窗口 -->
    <preview-picture
      ref="previewPicture"
      @handlerPreviewList="handlerPreviewList"
    ></preview-picture>
    <!-- 分页组件 -->
    <el-pagination
      :page-sizes="[10, 15, 20, 25, 50, 100]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > params.pageSize"
      @size-change="changeSize"
      style="padding-bottom: 30px"
      @current-change="changeCurrent"
    ></el-pagination>
    <comment-action ref="commentAction" @handleList="getVideoList('status')" />
  </div>
</template>

<script>
import MediaPopup from "@/components/media-popup";
import EditVideo from "./components/edit-video";
import BatchChildModule from "./components/batchChildModule.vue";
import baseConfig from "@/utils/serverUrlConfig";
import {changeTime, sortEscape} from "@/utils/global";
import PreviewPicture from "./components/previewPicture";
import CommentAction from "@/components/commentAction";
import API from "@/api";

export default {
  data() {
    return {
      checkData: [],
      showImgLoad: false,
      // 是否添加推送
      // 状态
      status: [
        {
          label: "全部状态",
          value: 5,
        },
        {
          label: "通过",
          value: 1,
        },
        {
          label: "未通过",
          value: 2,
        },
        {
          label: "视为免费",
          value: 3,
        },
        {
          label: "已删除",
          value: 0,
        },
      ],

      // 是否付费
      chosen: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "精选",
          value: 1,
        },
        {
          label: "非精选",
          value: 2,
        },
      ],
      secondModuleList: [],

      // 是否为免费专区
      free: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 2,
        },
      ],
      // 是否为用户
      isUserUp: [
        {
          label: "全部",
          value: 2,
        },
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 0,
        },
      ],
      // 是否免费
      isFree: [
        {
          label: "全部",
          value: 2,
        },
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 0,
        },
      ],
      // 是否撩吧置顶
      isLiaoBaTop: [
        {
          label: "全部",
          value: undefined,
        },
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],
      imgUrl: baseConfig.imgUrl,
      loading: false,
      // 列表数据
      tableData: [],
      total: "",
      time: "",
      // 请求列表查询
      params: {
        pageNumber: 1,
        pageSize: 15,
        isFree: 2,
        key: "",
        value: "",
        start: "",
        end: "",
        title: "",
        uid: "",
        tag: "",
        status: 5,
        isBlogger: true,
        chosen: 0,
        freeArea: 0,
        id: "",
        newsType: 1,
        isTopping: undefined,
        reviewAccount: "wfy",
        empty:"",
      },
    };
  },
  components: {
    MediaPopup,
    EditVideo,
    PreviewPicture,
    CommentAction,
    BatchChildModule,
  },
  watch: {
    $route(to) {
      var currentPath = to.fullPath;
      var index = currentPath.lastIndexOf("/") + 1;
      var vtype = currentPath.substring(index, currentPath.length);
      this.params.newsType = vtype * 1;
      this.params.empty = ''
      this.getVideoList();
      this.getHotModule();
    },
  },
  mounted() {
    this.getVideoList();
    this.getHotModule();
  },
  methods: {
    getHotModule() {
      const params = {
        pageSize: 20,
        pageNumber: 1,
      };
      API.getModuleList(params).then((res) => {
        this.secondModuleList = this.transformData(res.data);
      });
    },

    transformData(originalData) {
      return originalData.map((module) => {
        return {
          value: module.moduleID,
          label: module.moduleName,
          children: module.list
            ? module.list.map((subModule) => {
                return {
                  value: subModule.moduleID,
                  label: subModule.moduleName,
                  children: subModule.subModules
                    ? subModule.subModules.map((item) => {
                        return {
                          value: item.id,
                          label: item.moduleName,
                        };
                      })
                    : null,
                };
              })
            : null,
        };
      });
    },
    handleChangeModule(val) {
      this.params.subModuleID = val;
    },

    // 打开评论弹出框
    openComment(row) {
      const params = Object.assign(
        {},
        {
          objID: row.id,
          level: 1,
        }
      );
      this.$refs.commentAction.open(params);
    },
    // 获取视频列表
    getVideoList(type) {
      this.showImgLoad = false;
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.getVideoList(this.params)
        .then((res) => {
          this.showImgLoad = true;
          if (res.code === 200 && res.data.vInfos) {
            this.tableData = res.data.vInfos;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // 下载原视频
    downloadMedia(row) {
      let sourceURL = new String(row.sourceURL);
      // eslint-disable-next-line no-useless-escape
      let index = sourceURL.lastIndexOf("/");
      let sourceUrl = sourceURL.substring(0, index + 1);
      let href = baseConfig.downLoadUrl + sourceUrl + row.fileName;
      window.open(href);
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getVideoList();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getVideoList();
    },
    // 时间触发回调
    changeTime(time) {
      if (time) {
        this.params.start = changeTime(time[0]) || "";
        this.params.end = changeTime(time[1]) || "";
      } else {
        this.params.start = "";
        this.params.end = "";
      }
      this.getVideoList("status");
    },
    // 编辑回调监听
    handlerVideoList() {
      this.getVideoList();
    },
    // 数据排序
    handleSortChange(column) {
      if (column.order) {
        this.params.value = sortEscape(column.order);
        this.params.key = column.prop;
      } else {
        this.params.value = "";
        this.params.key = "";
      }
      this.getVideoList();
    },
    // 推荐当前视频
    // addPush(row) {
    //   row.pushing = !row.pushing
    //   let text = row.pushing ? '您确定要取消推送当前视频吗？' : '您确定要推送当前视频吗？'
    //   this.$confirm( text, {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     if(row.pushing) {
    //       let params = {
    //         ids: [row.id],
    //       }
    //       API.cancelRecommend(params).then(res => {
    //         if (res.code === 200) {
    //           this.$message({
    //             message: '取消推送成功！',
    //             type: 'success'
    //           });
    //           this.getVideoList()
    //         } else {
    //           this.$message.error('取消推送失败！');
    //         }
    //       })
    //     } else {
    //       let params = {
    //         videoID: row.id,
    //         title: row.title,
    //       }
    //       API.setRecommend(params).then(res => {
    //         if (res.code === 200) {
    //           this.$message({
    //             message: '推送成功！',
    //             type: 'success'
    //           });
    //           this.getVideoList()
    //         } else {
    //           this.$message.error('推送失败！');
    //         }
    //       })
    //     }
    //   })
    // },
    // 图集预览
    previewPicture(pictureArr, id, tags,item) {
      let Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr, id, tags,item);
    },
    handlerPreviewList() {
      this.getVideoList();
    },
    // 设为精选/免费
    setChosen(row, type) {
      switch (type) {
        case "chosen":
          this.videoHighlights(row);
          break;
        case "free":
          this.freeZone(row);
          break;
        case "isTopping":
          this.sticky(row);
          break;
        case "isRecommend":
          this.isRecommend(row);
          break;
        case "isChoosen":
          this.isChoosen(row);
          break;
        case "isRecoWeight":
          this.isRecoWeight(row);
          break;
        case "liaoBaTop":
          this.liaoBaTop(row);
          break;
      }
    },
    // 查看媒体
    checkMedia(url, type) {
      let processedUrl = url.startsWith("/") ? url : "/" + url;
      this.$refs.mediaPopup.open(processedUrl, type);
    },
    // 删除视频
    removeVideo(id,index) {
      this.$confirm("您确定要删除当当前视频吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.deleteVideo({ ids: [id] }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.tableData.splice(index,1)
            if(this.tableData.length == 0)this.getVideoList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },

    //强送forcePush
    forcePush(row) {
      this.$confirm("您确定要将当前视频强行推送吗？", "操作提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.setRecommend({
          videoID: row.id,
          title: row.title,
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "强推成功！",
              type: "success",
            });
          } else {
            this.$message.error("强推失败！");
          }
        });
      });
    },
    // 置顶视频
    placement(row) {
      if (row.status === 2) {
        this.$message.error("未通过视频不能置顶！");
        return false;
      }
      this.$confirm("您确定要将当前视频置顶吗？", "操作提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.setChosen({
          ids: [row.id],
          field: "topping",
          status: true,
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "置顶成功！",
              type: "success",
            });
          } else {
            this.$message.error("置顶失败！");
          }
        });
      });
    },
    // 编辑视频
    edit(row) {
      const currentData = {
        ...row,
        uid: row.publisher.uid,
      };
      this.$refs.editVideo.open(currentData);
    },
    // 视频精选
    videoHighlights(row) {
      row.chosen = !row.chosen;
      let text = row.chosen
        ? "您确定要取消当前视频的精选推送吗？"
        : "您确定要推送当前视频至精选吗？";
      this.$confirm(text, "推送提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          ids: [row.id],
          field: "chosen",
          status: !row.chosen,
        };
        API.setChosen(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: params.status ? "推送至精选成功！" : "取消精选成功！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("推送至精选失败！");
          }
        });
      });
    },
    // 是否免费
    freeZone(row) {
      row.freeArea = !row.freeArea;
      let text = row.freeArea
        ? "您确定要取消设置为免费专区吗？"
        : "您确定要设置为免费专区吗？";
      this.$confirm(text, "免费设置提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          ids: [row.id],
          field: "freeArea",
          status: !row.freeArea,
        };
        API.setChosen(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: params.status ? "设置免费专区成功！" : "取消免费专区！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("设置免费专区失败！");
          }
        });
      });
    },
    // 是否置顶
    sticky(row) {
      row.isTopping = !row.isTopping;
      let text = row.isTopping ? "您确定要取消置顶吗？" : "您确定要置顶吗？";
      this.$confirm(text, "置顶提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          ids: [row.id],
          field: "isTopping",
          status: !row.isTopping,
        };
        API.setChosen(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: params.status ? "置顶成功！" : "取消置顶！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("置顶失败！");
          }
        });
      });
    },
    // 是否力荐
    isRecommend(row) {
      row.isRecommend = !row.isRecommend;
      let text = row.isRecommend
        ? "您确定要取消力荐该帖子吗？"
        : "您确定要力荐改帖子吗？";
      this.$confirm(text, "力荐提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          ids: [row.id],
          field: "isRecommend",
          status: !row.isRecommend,
        };
        API.setChosen(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: params.status ? "设置力荐成功！" : "取消力荐成功！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("设置力荐失败");
          }
        });
      });
    },
    // 是否设置围观
    isChoosen(row) {
      row.isChoosen = !row.isChoosen;
      let text = row.isChoosen ? "您确定要取消设置围观吗？" : "您确定要设置围观吗？";
      this.$confirm(text, "设置围观提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          ids: [row.id],
          field: "isChoosen",
          status: !row.isChoosen,
        };
        API.setChosen(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: params.status ? "设置围观成功！" : "取消设置围观！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("设置围观失败");
          }
        });
      });
    },
    // 是否推荐
    isRecoWeight(row) {
      row.isRecoWeight = !row.isRecoWeight;
      let text = row.isRecoWeight ? "您确定要取消推荐吗？" : "您确定要推荐吗？";
      this.$confirm(text, "推荐提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          ids: [row.id],
          field: "isRecoWeight",
          status: !row.isRecoWeight,
        };
        API.setChosen(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: params.status ? "推荐成功！" : "取消推荐！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("推荐失败");
          }
        });
      });
    },
    // 是否撩吧置顶
    liaoBaTop(row) {
      row.liaoBaTop = !row.liaoBaTop;
      let text = row.liaoBaTop
        ? "您确定要取消撩吧置顶吗？"
        : "您确定要撩吧置顶吗？";
      this.$confirm(text, "撩吧置顶提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          ids: [row.id],
          field: "liaoBaTop",
          status: !row.liaoBaTop,
        };
        API.setChosen(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: params.status ? "撩吧置顶成功！" : "取消撩吧置顶成功！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("撩吧置顶失败！");
          }
        });
      });
    },
    handleSelectionChange(val) {
      this.checkData = val;
    },
    getTrDom(dom){
      if(dom.tagName.toLowerCase() == "tr"){
        return dom;
      }
      return this.getTrDom(dom.parentElement)
    },
    handleBatchChildModule() {
      if (this.checkData.length === 0) {
        this.$message.error("请选择需要批量转移的子模块");
        return false;
      }
      const ids = [];
      this.checkData.forEach((item) => {
        ids.push(item.id);
      });
      const currentData = {
        ids,
      };
      this.$refs.batchChildModule.open(currentData);
    },

    handleBatchRemoves(status) {
      if (this.checkData.length === 0) {
        this.$message.error("请选择需要批量删除的帖子");
        return false;
      }
      const ids = [];
      this.checkData.forEach((item) => {
        ids.push(item.id);
      });

      const currentData = {
        ids,
        status: status, // 批量删除
      };

      var text = "高危操作，执行点击【确定】按钮?";
      var text2 = "是否批量删除当前选中帖子?"
      if (status == 1){
        text = "你确定执行批量恢复操作吗？";
        text2 = "是否批量恢复当前选中帖子？";
      }

      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(()=>{
        this.$confirm(text2, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(() => {
              API.batchModifyCoinAndRemoveSelf(currentData).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: "执行成功，如果误操作想恢复请联系技术处理！",
                    type: "success",
                  });
                  this.getVideoList();
                } else {
                  this.$message.error("执行失败！");
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "执行失败",
              });
            });

        this.checkData = [];
      })
    },

    // 批量下架
    handleBatchRemoveSelf() {
      if (this.checkData.length === 0) {
        this.$message.error("请选择需要批量下架的帖子");
        return false;
      }
      const ids = [];
      this.checkData.forEach((item) => {
        ids.push(item.id);
      });
      const currentData = {
        ids,
        status: 5, // 下架状态
      };
      this.$confirm("是否批量下架当前选中帖子?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          API.batchModifyCoinAndRemoveSelf(currentData).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "批量下架成功！",
                type: "success",
              });
              this.getVideoList();
            } else {
              this.$message.error("批量下架失败！");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消批量下架",
          });
        });

      this.checkData = [];
    },
    handleSearchNoCategory(){
      this.params.empty = this.params.empty == "1" ? "" :"1"
      this.getVideoList()
    },
    handleBatchModifyCoin() {
      if (this.checkData.length === 0) {
        this.$message.error("请选择需要批量修改金币价格的帖子");
        return false;
      }
      const ids = [];
      this.checkData.forEach((item) => {
        ids.push(item.id);
      });
      this.$prompt("请输入修改金币的价格", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: "金币价格不正确，请输入数字",
      })
        .then(({ value }) => {
          this.$message({
            type: "success",
            message: "修改的金币价格是: " + value,
          });
          const currentData = {
            ids,
            coins: Number(value), // 设置为0表示免费
          };
          API.batchModifyCoinAndRemoveSelf(currentData).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "批量修改金币价格成功！",
                type: "success",
              });
              this.getVideoList();
            } else {
              this.$message.error("批量修改金币价格失败！");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });

      this.checkData = [];
    },
    copyId(id) {
      // 创建一个临时的 textarea 元素
      const textarea = document.createElement("textarea");
      textarea.value = id;
      document.body.appendChild(textarea);
      // 选中文本
      textarea.select();
      // 执行复制命令
      document.execCommand("copy");
      // 移除临时元素
      document.body.removeChild(textarea);
      // 显示成功提示
      this.$message({
        message: `ID:${id} 复制成功.`,
        type: "success",
      });
    },
  },
};
</script>
<style scoped lang="scss">
.picturePreview {
  max-width: 300px;
  display: flex;
}
.videoList-box {
  background:#f8f8f8;
  border-radius: 4px;
  adding:10px;
  display: flex;
  flex-direction: column;
  .search-row {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
  }
}
</style>
